import React, { useEffect, memo } from 'react';

import { FocusContext, setFocus, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import Button from '@smart-tv/components/button/button';
import Typography from '@smart-tv/components/typography';
import { ForgotPasswordText } from '@smart-tv/pages/login/types';
import { IS_BROWSER } from '@smart-tv/utils/is-browser';
import testIds from '@smart-tv/e2e/shared/variables';

import styles from '../login.module.scss';

const FORGOT_PASSWORD_SUCCES_FOCUS_KEY = 'LoginForgotPasswordCheckEmailAfterSendPWButton';

interface Props {
  display: boolean;
  onClose: () => void;
  resetPasswordEmail: string;
  forgotPwText: ForgotPasswordText | undefined;
}

export const LoginForgotPasswordDialogSucces = (props: Props) => {
  const { onClose, resetPasswordEmail, display, forgotPwText } = props;
  const { focusKey } = useFocusable({ isFocusBoundary: true });

  useEffect(() => {
    if (display) {
      setFocus(FORGOT_PASSWORD_SUCCES_FOCUS_KEY);
    }
  }, [display]);

  if (!display) return null;

  return (
    <FocusContext.Provider value={focusKey}>
      <Typography className={styles['login-forgot-password-success-dialog__title']} variant="h3">
        {forgotPwText ? forgotPwText.emailSent : 'Tjek din e-mail'}
      </Typography>
      <Typography
        className={styles['login-forgot-password-success-dialog__description']}
        variant="body"
      >
        {forgotPwText
          ? forgotPwText.emailSentTo.replace('<indtastet_email>', resetPasswordEmail)
          : 'Vi har sendt dig en mail. Tjek din indbakke og følg linket for at nulstille din adgangskode. '}
      </Typography>
      <Typography
        className={styles['login-forgot-password-success-dialog__description']}
        variant="body"
      >
        {forgotPwText
          ? forgotPwText.help
          : 'Har du ikke fået mailen fra os? Så kan kundeservice hjælpe.'}
      </Typography>
      <Button
        className={styles['login-forgot-password-success-dialog__accept-button']}
        focusKey={FORGOT_PASSWORD_SUCCES_FOCUS_KEY}
        onClick={onClose}
      >
        Ok
      </Button>
      {IS_BROWSER && (
        <Button
          onClick={onClose}
          className={styles['login-forgot-password-dialog__back-button']}
          data-testid={testIds.login.forgotPasswordDialog.backButton}
        >
          Tilbage
        </Button>
      )}
    </FocusContext.Provider>
  );
};

export default memo(LoginForgotPasswordDialogSucces);
